export const RESET_CACHE = 'utair/resetCache/RESET';

// Action Creators
export const resetCache = () => ({type: RESET_CACHE});
